import { connect, useDispatch } from 'react-redux';
import * as Actions from '../../../../../services/redux/deliveryNotes/actions';
import PropTypes from '../../../../../utils/propTypes';
import TraceabilityTable from './components/TraceabilityTable';
import { useCallback, useEffect, useState } from 'react';
import ViewModal from './components/ViewModal';
import EditModal from './components/EditModal';
import { getElements } from '../../../../../services/api/elements';

const CustomTraceabilityList = ({ normative }) => {
  const dispatch = useDispatch();
  const [itemToView, setItemToView] = useState();
  const [itemToEdit, setItemToEdit] = useState();
  const [itemsToEditOnBulk, setItemsToEditOnBulk] = useState();
  const [structuralElements, setStructuralElements] = useState();
  const [selectedRows, setSelectedRows] = useState([]);
  const [params, setParams] = useState({});

  function getCommonValues(data) {
    if (data.length === 0) return {};

    const keys = Object.keys(data[0]);
    const result = {};

    for (const key of keys) {
      const firstValue = data[0][key];
      const allEqual = data.every((item) => item[key] === firstValue);
      result[key] = allEqual ? firstValue : undefined;
    }

    return result;
  }

  useEffect(() => {
    const getStructuralElements = async () => {
      const { data } = await getElements();
      if (data?.data) {
        setStructuralElements(data.data);
      }
    };

    if (normative === 'coe') {
      getStructuralElements();
    } else {
      setStructuralElements([
        { structural_element: 'MACIZOS', id: 1 },
        { structural_element: 'COMPRESIÓN', id: 2 },
        { structural_element: 'FLEXIÓN', id: 3 },
      ]);
    }
  }, [normative]);

  const handleOnParamsChange = useCallback((newParams) => {
    setParams(newParams);
  }, []);

  return (
    <>
      <TraceabilityTable
        onViewClick={setItemToView}
        onEditClick={setItemToEdit}
        normative={normative}
        structuralElements={structuralElements}
        onParamsChange={handleOnParamsChange}
        onEditOnBulkClick={(items) => {
          const syntheticItem = getCommonValues(items);
          setItemsToEditOnBulk(items);
          setItemToEdit({
            ...syntheticItem,
            rawData: syntheticItem,
          });
        }}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
      />
      <ViewModal
        item={itemToView}
        onClose={() => setItemToView(undefined)}
        normative={normative}
      />
      <EditModal
        item={itemToEdit}
        itemsToEditOnBulk={itemsToEditOnBulk}
        onClose={() => {
          dispatch(Actions.getDeliveryNotes(params));
          setItemToEdit(undefined);
          setItemsToEditOnBulk(undefined);
          setSelectedRows([]);
        }}
        onCancel={() => {
          setItemToEdit(undefined);
          setItemsToEditOnBulk(undefined);
        }}
        normative={normative}
        structuralElements={structuralElements}
      />
    </>
  );
};

CustomTraceabilityList.propTypes = {
  getDeliveryNotes: PropTypes.func.isRequired,
  cleanReducer: PropTypes.func.isRequired,
  normative: PropTypes.oneOf(['coe', 'ehe']).isRequired,
};

export default connect(() => ({}), {
  getDeliveryNotes: Actions.getDeliveryNotes,
  cleanReducer: Actions.initReducer,
})(CustomTraceabilityList);
